
import {
  Avatar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  TextField,
  ListItemIcon,
  Divider,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LoginIcon from "@mui/icons-material/Login";
import PeopleIcon from "@mui/icons-material/People";
import InventoryIcon from "@mui/icons-material/Inventory";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FeedbackIcon from "@mui/icons-material/Feedback";

export default function Navbar() {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const email = localStorage.getItem("email");
  const adminEmail = "karanksxxxx@gmail.com";

  const toggleDrawer = (open) => setDrawerOpen(open);
  const handleSearchChange = (e) => setSearchQuery(e.target.value);

  const allLinks = [
    { name: "Dashboard", path: "/", icon: <DashboardIcon /> },
    { name: "Billing", path: "/Billing", icon: <ReceiptIcon /> },
    { name: "Orders", path: "/Orders", icon: <ShoppingCartIcon /> },
    { name: "Login", path: "/Login", icon: <LoginIcon /> },
    ...(email === adminEmail
      ? [
          { name: "Users", path: "/Users", icon: <PeopleIcon /> },
          { name: "Products", path: "/Products", icon: <InventoryIcon /> },
          { name: "Confirmorders", path: "/Confirmorders", icon: <CheckCircleIcon /> },
          { name: "Feedback", path: "/Feedback", icon: <FeedbackIcon /> },
        ]
      : []),
  ].filter((link) =>
    link.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <header className="navbar">
        <div className="navbar-left">
          <Link to="/">
            <h1 className="brand">KP BAKERS</h1>
          </Link>
        </div>
        <div className="navbar-center desktop-menu">
          {allLinks.map((link) => (
            <Link key={link.name} to={link.path}>
              <Button className="nav-link">{link.name}</Button>
            </Link>
          ))}
        </div>
        <div className="navbar-right">
          {email && (
            <Link to="/Profile">
              <Avatar
                src={localStorage.getItem("profilePic") || ""}
                alt="Profile"
                sx={{ width: 40, height: 40 }}
              >
                {!localStorage.getItem("profilePic") && email.charAt(0).toUpperCase()}
              </Avatar>
            </Link>
          )}
          <IconButton className="mobile-menu" onClick={() => toggleDrawer(true)}>
            <MenuIcon sx={{ color: "#fff" }} />
          </IconButton>
        </div>
      </header>

      <Drawer anchor="right" open={drawerOpen} onClose={() => toggleDrawer(false)}>
        <div className="drawer">
          <TextField
            placeholder="Search..."
            variant="outlined"
            value={searchQuery}
            onChange={handleSearchChange}
            fullWidth
            sx={{ marginBottom: 2 }}
          />
          <Divider />
          <List>
            {allLinks.map((link) => (
              <ListItem
                button
                key={link.name}
                onClick={() => {
                  navigate(link.path);
                  toggleDrawer(false);
                }}
              >
                <ListItemIcon>{link.icon}</ListItemIcon>
                <ListItemText primary={link.name} />
              </ListItem>
            ))}
          </List>
        </div>
      </Drawer>

      <style jsx>{`
        .navbar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #111;
          padding: 0 24px;
          height: 72px;
          color: white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
          position: fixed;
          width: 100%;
          top: 0;
          z-index: 999;
        }

        .brand {
          font-size: 24px;
          font-weight: 700;
          color: #ffb703;
          margin: 0;
          text-decoration: none;
          letter-spacing: 2px;
        }

        .navbar-center {
          display: flex;
          gap: 20px;
        }

        .nav-link {
  position: relative;
  color: cyan;
  background: transparent;
  font-weight: 500;
  font-size: 16px;
  padding: 8px 16px;
  border: none;
  background: none;
  text-transform: capitalize;
  cursor: pointer;
  transition: color 0.3s ease;
  text-decoration: none;
}

.nav-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 4px;
  width: 100%;
  height: 2px;
  background-color: #ffb703;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.nav-link:hover::after {
  transform: scaleX(1);
}

.nav-link:hover {
  color: #ffb703;
}

        .navbar-right {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .mobile-menu {
          display: none;
        }

        .drawer {
          width: 260px;
          padding: 20px;
        }

        @media (max-width: 768px) {
          .desktop-menu {
            display: none;
          }

          .mobile-menu {
            display: block;
          }

          .brand {
            font-size: 20px;
          }
        }
      `}</style>
    </>
  );
}
